import React from "react"

const AwardBadgeSVG = ({
  bgColor = "#FFD700",
  logoBgColor = "#003E4C",
  width = "50px",
  height = "50px",
  year = "2023"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 206 300"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35075_16293)">
        <path
          d="M150.629 136.212L172.032 222.059L132.939 215.514L132.509 215.441L132.163 215.708L100.889 239.794L79.4863 153.95L150.629 136.212Z"
          fill={bgColor}
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M125.16 162.95L103.762 248.774L73.8937 225.214L73.5548 224.947L73.1262 225.011L32.6074 231.085L54.0179 145.212L125.16 162.95Z"
          fill={bgColor}
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M102.747 2.11914L124.183 13.623H149.628L149.924 14.0762L163.405 34.7002L185.628 45.9375L186.124 46.1885L186.172 46.7412L188.367 71.1338L203.086 91.6602L203.406 92.1055L203.203 92.6133L193.962 115.759L197.453 140.317L197.53 140.864L197.108 141.221L178.674 156.816L170.013 180.769L169.825 181.291L169.282 181.407L145.067 186.572L127.071 203.724L126.658 204.118L126.109 203.962L102.772 197.346L78.4292 203.965L77.8853 204.113L77.4771 203.724L59.48 186.572L35.2661 181.407L34.7026 181.287L34.5239 180.739L26.8696 157.319L7.44775 141.228L7.00342 140.859L7.09912 140.291L11.0825 116.763L1.34619 92.6172L1.13721 92.0977L1.47021 91.6475L16.6792 71.1338L18.3735 46.7607L18.4136 46.1826L18.936 45.9297L41.1431 35.2012L54.6177 14.085L54.9272 13.5996L55.5034 13.624L79.8657 14.6729L101.777 2.13184L102.258 1.85645L102.747 2.11914Z"
          fill={bgColor}
          stroke="black"
          strokeWidth="2"
        />
        <path
          d="M102.274 179C144.248 179 178.274 144.974 178.274 103C178.274 61.0264 144.248 27 102.274 27C60.3003 27 26.2739 61.0264 26.2739 103C26.2739 144.974 60.3003 179 102.274 179Z"
          stroke="black"
          strokeWidth="2"
        />
        <mask maskUnits="userSpaceOnUse" x="46" y="64" width="113" height="78">
          <path d="M158.274 64H46.2739V142H158.274V64Z" fill="white" />
        </mask>
        <g mask="url(#mask0_35075_16293)">
          <path
            d="M89.9777 142H66.1797L46.2739 64H67.403L78.3012 119.157L91.6458 64H113.22L126.231 119.046L137.24 64H158.258L138.352 142H114.665L102.322 91.5229L89.9777 142Z"
            fill={logoBgColor}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_35075_16293">
          <rect width="205" height="251" fill="white" />
        </clipPath>
      </defs>
      <text fill={logoBgColor} fontFamily="Albert Sans" fontSize="60" fontWeight="bold">
        <tspan x="44" y="290">
          {year}
        </tspan>
      </text>
    </svg>
  )
}

export default AwardBadgeSVG
